import React from 'react';
import { iconStyle } from './styles';

export const Rainy: React.FC<{ size?: string }> = ({ size }) => {
  return (
    <div style={iconStyle(size)}>
      <svg
        width="100px"
        height="100px"
        viewBox="0 0 100 100"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g
          id="Parent-View---Family-Profile"
          stroke="none"
          strokeWidth="1"
          fill="none"
          fillRule="evenodd"
        >
          <g
            id="2-Family-Profile---Parent-Goals"
            transform="translate(-137.000000, -753.000000)"
          >
            <g
              id="Goal---Education-Fund"
              transform="translate(17.000000, 665.000000)"
            >
              <g
                id="Progress-+-icon"
                transform="translate(115.000000, 83.000000)"
              >
                <circle
                  id="Oval-5"
                  fill="#095C8D"
                  cx="55"
                  cy="55"
                  r="50"
                ></circle>
                <g
                  id="icon-/-rainy-day-/-white"
                  transform="translate(27.000000, 28.000000)"
                  fillRule="nonzero"
                  stroke="#FFFFFF"
                >
                  <path
                    d="M27.6514069,28.6004274 L27.6514069,47.0299145 C27.6514069,48.7393162 26.1290648,50.1282051 24.255413,50.1282051 C22.3817612,50.1282051 20.8594192,48.7393162 20.8594192,47.0299145 C20.8594192,46.1752137 20.0982481,45.4273504 19.1028706,45.4273504 C18.1074931,45.4273504 17.3463221,46.1217949 17.3463221,47.0299145 C17.3463221,50.5021368 20.4495579,53.3333333 24.255413,53.3333333 C28.0612682,53.3333333 31.1645039,50.5021368 31.1645039,47.0299145 L31.1645039,28.6004274 C30.696091,28.4401709 30.1105748,28.3333333 29.4079554,28.3333333 C28.705336,28.3333333 28.1198198,28.4401709 27.6514069,28.6004274 Z"
                    id="Path"
                  ></path>
                  <path
                    d="M31.1809465,5.88993711 L31.1809465,3.27044025 C31.1809465,2.36163522 30.4419907,1.66666667 29.4756639,1.66666667 C28.5093371,1.66666667 27.7703813,2.36163522 27.7703813,3.27044025 L27.7703813,5.88993711 C16.2313024,6.74528302 7.02277642,16.4748428 6.90909091,28.3427673 C6.90909091,29.091195 7.53436119,29.7327044 8.33015974,29.7861635 C9.18280104,29.8396226 9.80807132,29.2515723 9.86491408,28.4496855 C9.97859958,26.5786164 12.4796807,25.0283019 15.3786611,25.0283019 C18.3913271,25.0283019 20.8924082,26.6855346 20.8924082,28.6100629 C20.8924082,29.4119497 21.5745212,30 22.3703198,30 C23.2229611,30 23.8482314,29.3584906 23.8482314,28.6100629 C23.8482314,26.6855346 26.4061553,25.0283019 29.3619784,25.0283019 C32.3746444,25.0283019 34.8757255,26.6855346 34.8757255,28.6100629 C34.8757255,29.4119497 35.5578385,30 36.3536371,30 C37.2062784,30 37.8315487,29.3584906 37.8315487,28.6100629 C37.8315487,26.6855346 40.3326298,25.0283019 43.3452957,25.0283019 C46.2442761,25.0283019 48.7453573,26.5786164 48.8590428,28.4496855 C48.9158855,29.1981132 49.5979986,29.7861635 50.3937971,29.7861635 C51.1895957,29.7327044 51.8717087,29.1446541 51.814866,28.3427673 C51.9285515,16.4748428 42.7200254,6.74528302 31.1809465,5.88993711 Z"
                    id="Path"
                  ></path>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
};
